const WidgetCategory = () => import('@/views/widgets/WidgetCategory');
// const MainWidget = () => import('@/views/widgets/MainWidget');

const mainWidget = [
  // {
  //   path: "/admin/widget",
  //   name: "Widget",
  //   // redirect: '/admin/widget/revenue-tourism'
  //   redirect: to => {
  //     console.log('redirect', to)
  //     return { path: '/admin/widget/voice-of-customer' }
  //   }
  // },
  {
    title: 'หมวดหมู่ Widget',
    path: '/admin/widget/:category',
    component: WidgetCategory,
  }
]

export default mainWidget.map(data => {
  const { path, title, component, redirect, children } = data

  return {
    path: path,
    name: title,
    component: component,
    redirect: redirect,
    meta: {
      title: title,
      requiresAuth: true,
      breadcrumb: title
    },
    children: children
  }
})